import { Component, ContentType } from 'contensis-core-api';
import { FormContentType } from '~/models/FormContentTypeManagement';
import { FormContentTypeAssertions } from './FormContentTypeAssertions';

type ResourceType = ContentType | Component | FormContentType;

/**
 * Content Type assertion functions
 */
export class ContentTypeAssertions {
  static form = FormContentTypeAssertions;

  static isContentType = (
    resource: ResourceType
  ): resource is ContentType | FormContentType =>
    resource && 'defaultLanguage' in resource ? true : false;

  static isComponent = (
    resource: ResourceType | undefined
  ): resource is Component =>
    resource && !('defaultLanguage' in resource) ? true : false;

  static isEntryContentType = (
    resource: ResourceType
  ): resource is ContentType & { dataFormat: 'entry' } =>
    ContentTypeAssertions.isContentType(resource) &&
    resource.dataFormat === 'entry';

  static isFormContentType = (
    resource: ResourceType
  ): resource is FormContentType & { dataFormat: 'form' } =>
    ContentTypeAssertions.isContentType(resource) &&
    resource.dataFormat === 'form';

  static isAssetContentType = (
    resource: ResourceType
  ): resource is ContentType & { dataFormat: 'asset' } =>
    ContentTypeAssertions.isContentType(resource) &&
    resource.dataFormat === 'asset';

  static isWebpageContentType = (
    resource: ResourceType
  ): resource is FormContentType & { dataFormat: 'webpage' } =>
    ContentTypeAssertions.isContentType(resource) &&
    (resource.dataFormat as any) === 'webpage';

  static isPublished = (resource: ResourceType) =>
    ContentTypeAssertions.isContentType(resource) &&
    !!resource.version?.published;
}
